<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :rules="dataForm.rulesCompanyGroup"
        :submit="handleSubmitFormAddGroup"
        :undo-enable="true"
        :title="$t('labels.addCompanyGroup')"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div
                    class="hts-vehicles-ignore-add-vehicle__container-body"
                    :class="sizeItemInput">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <span class="label">
                                    {{ $t('labels.generalInformation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-5"
                            :class="columnClass">
                            <hts-form-input
                                v-model="dataFormAddCompanyGroup.name"
                                :label="$t('labels.groupName')"
                                :required="true"
                                :color="props.color"
                                name="name"
                                prop="name" />
                            <hts-form-input
                                :required="true"
                                :label="$t('labels.companyName')"
                                :placeholder="companyName"
                                :color="props.color"
                                :disabled="true"
                                name="company"
                                prop="company" />
                            <hts-form-input
                                v-model="dataFormAddCompanyGroup.description"
                                :label="$t('labels.description')"
                                :color="props.color"
                                name="description"
                                prop="description" />
                        </div>
                    </hts-card>
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <span class="label">
                                    {{ $t('labels.groupPermissions') }}
                                </span>
                            </h3>
                        </template>

                        <div class="flex align-middle justify-end mb-2">
                            <span class="text-lg font-bold">
                                {{ $t('labels.checkAll') }}
                            </span>
                            <input
                                class="mt-2 ml-2"
                                type="checkbox"
                                :checked="isCheckAll"
                                @change="(e) => actionCheckAll()" >
                        </div>
                        <permission-checkbox
                            :permissions="permissionRef"
                            :action-checkbox="actionCheckbox"
                            :action-sub-checkbox="actionSubCheckbox"
                            :data-group-permissions="dataGroupPermissions" />
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import PermissionCheckbox from './ignore/permission-checkbox.vue'
import dataForm from './imports/model'
import permissions from '~/data/permissions/partner'
const store = $store()
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
  resetValue()
})

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: [String, Number],
    default: 'screen-lg'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})
const dataGroupPermissions = ref<Array<String>>([])
const permissionRef = reactive([...permissions])
const isCheckAll = ref(false)
const emits = defineEmits(['close', 'refreshTables'])

const resetValue = () => {
  dataGroupPermissions.value = []
}

const closeOverSide = () => {
  emits('close')
}

const dataFormAddCompanyGroup = reactive({ ...dataForm.initValue })
const undo = () => {
  Object.assign(dataFormAddCompanyGroup, { ...dataForm.initValue })
}
const actionCheckbox = (e: any, permission: any, action: boolean) => {
  e.stopPropagation()
  if (action) {
    if (!dataGroupPermissions.value.includes(permission.permissionKey)) {
      dataGroupPermissions.value.push(permission.permissionKey)
    }
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permission.permissionKey
    })
  }

  if (!permission.children) {
    return
  }

  permission.children.map((item: any) => {
    return actionCheckbox(e, item, action)
  })
  parentCheck()
}

const actionSubCheckbox = (e: any, permissionKey: string) => {
  if (!dataGroupPermissions.value.includes(permissionKey)) {
    dataGroupPermissions.value.push(permissionKey)
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permissionKey
    })
  }
  parentCheck()
}

const parentCheck = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  const result = data.map((item: any) => {
    if (!item.children) {
      return false
    }

    const check = item.children.map((children: { [key: string]: any }) => {
      if (children.children) {
        return parentCheck([children])
      }
      return dataGroupPermissions.value.includes(children.permissionKey)
    })

    if (check.includes(true)) {
      if (!dataGroupPermissions.value.includes(item.permissionKey)) {
        dataGroupPermissions.value.push(item.permissionKey)
      }
      return true
    } else {
      dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
        return ele !== item.permissionKey
      })
      return false
    }
  })

  return result.includes(true)
}

const actionCheckAll = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  if (!permission) {
    isCheckAll.value = !isCheckAll.value
  }
  if (!isCheckAll.value) {
    dataGroupPermissions.value = []
    return
  }
  data.map((item: any) => {
    if (!dataGroupPermissions.value.includes(item.permissionKey)) {
      dataGroupPermissions.value.push(item.permissionKey)
    }

    if (!item.children) {
      return item
    }

    item.children.map((subItem: any) => {
      if (!subItem.children) {
        if (subItem.isDisabled !== undefined) {
          subItem.isDisabled = !isCheckAll.value
        }
        dataGroupPermissions.value.push(subItem.permissionKey)
        return ''
      } else {
        return actionCheckAll([subItem])
      }
    })
    return ''
  })
}

const handleSubmitFormAddGroup = () => {
  const api = $url.companyGroup.addGroup
  const dataRequest = { ...dataFormAddCompanyGroup, permissions: dataGroupPermissions.value }
  $api(api, { body: dataRequest })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        resetValue()
        dataGroupPermissions.value = []
        emits('refreshTables')
        process.client && $toast().success($t('labels.addSuccess'))
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})
</script>
~/data/permissions/partner/permissions ~/data/permissions/partner
